import { useHistory, useLocation } from 'react-router-dom'
import { LOCATION_STATES } from 'utils/constants'
import { useEffect, useState } from 'react'

interface State<T> {
  popup: T
}

const usePopupState = <T = unknown>() => {
  const [popup, setPopup] = useState<T | undefined>(undefined)
  const { state, pathname, search } = useLocation<State<T>>()

  const { push, replace } = useHistory()
  const openPopup = (popup: string | object, isReplace?: boolean) => {
    const action = isReplace ? replace : push
    action(pathname + search, LOCATION_STATES.popup(popup))
  }

  useEffect(() => {
    const isPopup = state?.popup
    if (isPopup) setPopup(isPopup)
    else {
      const delay = isPopup === 'basket' ? 500 : 200
      const timeout = setTimeout(() => setPopup(isPopup), delay)
      return () => {
        clearTimeout(timeout)
      }
    }
  }, [state?.popup])

  return {
    popup,
    pathname,
    openPopup
  }
}

export default usePopupState